<div class="component-wrapper">
    <div class="component-content">
        <header>
            <div>
                <h1 [trimRichtextAriaLabel]="willkommenstext | translate" class="willkommens-text" [innerHTMLBypassXSS]="willkommenstext"></h1>
            </div>
            <div class="info-text" [trimRichtextAriaLabel]="infotextUebersicht | translate">
                <p [innerHTMLBypassXSS]="infotextUebersicht"></p>
            </div>
        </header>
        
        <div *ngIf="sortByFoerderprogramme">
            <section class="ausschreibung-foerderbereich" *ngFor="let foerderbereich of foerderprogramme; let i = index;">
                <h1>{{foerderbereich.title}}</h1>
                <div class="gap-2.5 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3">
                    <ausschreibung-card *ngFor="let ausschreibung of foerderbereich.ausschreibungen" [ausschreibung]="ausschreibung"></ausschreibung-card>
                </div>
                <span *ngIf="isNoEntryMessageVisible(i)" translate>tender.none_available</span>
            </section>
        </div>

        <section *ngIf="sortByAusschreibungsname">
            <div class="gap-2.5 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3">
                <ausschreibung-card *ngFor="let ausschreibung of sortedAusschreibungen" [ausschreibung]="ausschreibung"></ausschreibung-card>
            </div>
        </section>
    </div>
</div>